import axios from "axios";

// ── API URL Options ──────────────────────────────────────────────────
// Production: https://sms.bemydev.com → AAPanel reverse proxy → Docker port 5000
export const API = "/api";
// Direct IP access (for testing before DNS propagates):
// export const API = "http://66.29.142.135:5000/api";
// Local development:
// export const API = "http://localhost:5000/api";
// Production:
// export const API = "http://localhost:5001/api";

// ─────────────────────────────────────────────────────────────────────

// Custom Event Dispatcher
const triggerLoader = (show) => {
    const event = new CustomEvent("loader-change", { detail: show });
    window.dispatchEvent(event);
};

// Add a request interceptor
axios.interceptors.request.use(
    (config) => {
        if (!config.skipLoader) triggerLoader(true); // Show Loader
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        triggerLoader(false); // Hide Loader
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    (response) => {
        if (!response.config.skipLoader) triggerLoader(false); // Hide Loader
        return response;
    },
    (error) => {
        triggerLoader(false); // Hide Loader

        // Handle 401 (Unauthorized) or Network Error (Backend Down)
        if (error.response && error.response.status === 401) {
            console.warn("Session expired or unauthorized. Logging out.");
            localStorage.removeItem("token");
            window.location.href = "/login";
        } else if (!error.response && error.code === "ERR_NETWORK") {
            // Backend is probably down
            console.error("Network Error: Backend might be down.");
            alert("Connection lost. Please check your internet or try again later.");
            // Optional: Logout on network error too?
            // localStorage.removeItem("token");
            // window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);
